/* eslint-disable react-hooks/exhaustive-deps */
import { Column, SubtitleSection } from "components/styles";
import CustomButton from "components/CustomButton/CustomButton";
import DisketIcon from "icons/DisketIcon";
import { RESERVATION_STATE_VALUES } from "../../RegularReservationActivity/RegularReservationView/utils/constants";
import ReservationStateField from "./ReservationStateField";
import DialogSaveInformationConfirmation from "./DialogSaveInformationConfirmation";
import DialogResponsibleNotAttended from "./DialogResponsibleNotAttended";

const ReservationState = ({
    reservation, reservationState,
    saveReservationInformationHandler: { 
        dialogResponsibleNotAttended,
        dialogSaveInformationConfirmation,
        saveReservationInformation
    }
}) => {
    const { finalized, space } = reservation;
    //#region Functions
    function mustDisableSaveInformationButton() {
        return (
            !reservationState.value 
            || finalized 
            || (
                reservationState.hasState
                && reservationState.hasBeenChanges()
                && reservationState.value === RESERVATION_STATE_VALUES.ON_USE
            )
        );
    }
    //#endregion
    return (
        <>
            <Column>
                <SubtitleSection>Estado de reserva</SubtitleSection>
                <ReservationStateField 
                    reservationState={reservationState} 
                    finalized={finalized} />
                <CustomButton
                    text="Guardar información"
                    icon={<DisketIcon />}
                    width="100%"
                    onClick={dialogSaveInformationConfirmation.open}
                    disabled={mustDisableSaveInformationButton()} />
            </Column>
            <DialogSaveInformationConfirmation
                dialog={dialogSaveInformationConfirmation}
                space={space}
                saveInformation={saveReservationInformation}/>
            <DialogResponsibleNotAttended
                dialogCannotSaveInformation={dialogResponsibleNotAttended}
                space={space}/>
        </>
    );
}

export default ReservationState;